module.exports = __webpack_public_path__ + "assets/69f44770155ae7fb30e2613cc201d238.png";